import React from 'react';
import styles from '../darcielalesquim_fotografias/darcielalesquim_fotografias.module.scss';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HallIcon from '../../icons/hallIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import CameraIcon from '../../icons/cameraIcon.tsx';

const darcielalesquim_fotografias: React.FC = () => {

    return (
        <div className={styles.darcielalesquim_fotografias}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <h1 className="pt-2">Darciela Lesquim</h1>
                    <p>FOTOGRAFIAS</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5517981800385?text=Olá, gostaria de agendar um horário..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/mrokdycP15khA8DN7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/darcielalesquim_fotografias?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                paddingBottom: "5px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="/darcielalesquim_fotografias/galeria"
                            title="GALERIA"
                            icon={<CameraIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default darcielalesquim_fotografias;
